import React from 'react';
import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';

import {
	BENEFIT_ADOBE_ANALYTICS_INTEGRATION,
	BENEFIT_COBRANDING,
	BENEFIT_CORE_WEB_VITALS_ORIGIN_SUMMARY,
	BENEFIT_CUSTOM_ALERT_TRIGGER,
	BENEFIT_CUSTOM_ELEMENTS_0,
	BENEFIT_CUSTOM_ELEMENTS_10,
	BENEFIT_CUSTOM_ELEMENTS_2,
	BENEFIT_CUSTOM_ELEMENTS_5,
	BENEFIT_DATA_RETENTION_12_MONTHS,
	BENEFIT_DATA_RETENTION_6_MONTHS,
	BENEFIT_DATA_RETENTION_9_MONTHS,
	BENEFIT_GOOGLE_LOOKER_STUDIO,
	BENEFIT_ISSUES_CONFIGURATION,
	BENEFIT_LIGHTHOUSE_MONITORING,
	BENEFIT_LOG_FILE_ANALYSIS,
	BENEFIT_MICROSOFT_TEAMS,
	BENEFIT_REALTIME_INDEX_NOW,
	BENEFIT_RENDERING,
	BENEFIT_REPORTING_API,
	BENEFIT_UNLIMITED_USERS,
	BENEFIT_UNLIMITED_WEBSITES,
} from '~/model/benefits';



const messages = defineMessages({
	adobeAnalyticsIntegration: {
		id: 'ui.pricing.agency.benefits.adobeAnalyticsIntegration',
	},
	cobranding: {
		id: 'ui.pricing.agency.benefits.customLogo',
	},
	coreWebVitalsOriginSummary: {
		id: 'ui.pricing.agency.benefits.coreWebVitalsOriginSummary',
	},
	customAlertTrigger: {
		id: 'ui.pricing.agency.benefits.customAlertTrigger',
	},
	customElements: {
		id: 'ui.pricing.agency.benefits.customElements',
	},
	dataRetention: {
		id: 'ui.pricing.agency.benefits.dataRetention',
	},
	googleLookerStudio: {
		id: 'ui.pricing.agency.benefits.googleLookerStudio',
	},
	issuesConfiguration: {
		id: 'ui.pricing.agency.benefits.issuesConfiguration',
	},
	lighthouseMonitoring: {
		id: 'ui.pricing.agency.benefits.lighthouseMonitoring',
	},
	logFileAnalysis: {
		id: 'ui.pricing.agency.benefits.logFileAnalysis',
	},
	microsoftTeams: {
		id: 'ui.pricing.agency.benefits.microsoftTeams',
	},
	realtimeIndexNow: {
		id: 'ui.pricing.agency.benefits.realtimeIndexNow',
	},
	rendering: {
		id: 'ui.pricing.agency.benefits.rendering',
	},
	reportingApi: {
		id: 'ui.pricing.agency.benefits.reportingAPI',
	},
	unlimitedUsers: {
		id: 'ui.pricing.agency.benefits.unlimitedUsers',
	},
	unlimitedWebsites: {
		id: 'ui.pricing.agency.benefits.unlimitedWebsites',
	},
});



type Props = {
	disabled: boolean,
	name: string,
};

const BenefitLabel: React.FC<Props> = (props) => {
	const {
		disabled,
		name,
	} = props;

	if (name === BENEFIT_ADOBE_ANALYTICS_INTEGRATION) {
		return (
			<FormattedMessage
				{...messages.adobeAnalyticsIntegration}
				values={{
					enabled: disabled ? 'no' : 'yes',
				}}
			/>
		);
	} else if (name === BENEFIT_COBRANDING) {
		return (
			<FormattedMessage {...messages.cobranding} />
		);
	} else if (name === BENEFIT_CORE_WEB_VITALS_ORIGIN_SUMMARY) {
		return (
			<FormattedMessage
				{...messages.coreWebVitalsOriginSummary}
				values={{
					enabled: disabled ? 'no' : 'yes',
				}}
			/>
		);
	} else if (name === BENEFIT_CUSTOM_ALERT_TRIGGER) {
		return (
			<FormattedMessage
				{...messages.customAlertTrigger}
				values={{
					enabled: disabled ? 'no' : 'yes',
				}}
			/>
		);
	} else if (name === BENEFIT_CUSTOM_ELEMENTS_0) {
		return (
			<FormattedMessage
				{...messages.customElements}
				values={{
					number: 0,
				}}
			/>
		);
	} else if (name === BENEFIT_CUSTOM_ELEMENTS_2) {
		return (
			<FormattedMessage
				{...messages.customElements}
				values={{
					number: 2,
				}}
			/>
		);
	} else if (name === BENEFIT_CUSTOM_ELEMENTS_5) {
		return (
			<FormattedMessage
				{...messages.customElements}
				values={{
					number: 5,
				}}
			/>
		);
	} else if (name === BENEFIT_CUSTOM_ELEMENTS_10) {
		return (
			<FormattedMessage
				{...messages.customElements}
				values={{
					number: 10,
				}}
			/>
		);
	} else if (name === BENEFIT_DATA_RETENTION_6_MONTHS) {
		return (
			<FormattedMessage
				{...messages.dataRetention}
				values={{
					months: 6,
				}}
			/>
		);
	} else if (name === BENEFIT_DATA_RETENTION_9_MONTHS) {
		return (
			<FormattedMessage
				{...messages.dataRetention}
				values={{
					months: 9,
				}}
			/>
		);
	} else if (name === BENEFIT_DATA_RETENTION_12_MONTHS) {
		return (
			<FormattedMessage
				{...messages.dataRetention}
				values={{
					months: 12,
				}}
			/>
		);
	} else if (name === BENEFIT_GOOGLE_LOOKER_STUDIO) {
		return (
			<FormattedMessage
				{...messages.googleLookerStudio}
				values={{
					enabled: disabled ? 'no' : 'yes',
				}}
			/>
		);
	} else if (name === BENEFIT_ISSUES_CONFIGURATION) {
		return (
			<FormattedMessage
				{...messages.issuesConfiguration}
				values={{
					enabled: disabled ? 'no' : 'yes',
				}}
			/>
		);
	} else if (name === BENEFIT_LIGHTHOUSE_MONITORING) {
		return (
			<FormattedMessage
				{...messages.lighthouseMonitoring}
				values={{
					enabled: disabled ? 'no' : 'yes',
				}}
			/>
		);
	} else if (name === BENEFIT_LOG_FILE_ANALYSIS) {
		return (
			<FormattedMessage
				{...messages.logFileAnalysis}
				values={{
					enabled: disabled ? 'no' : 'yes',
				}}
			/>
		);
	} else if (name === BENEFIT_MICROSOFT_TEAMS) {
		return (
			<FormattedMessage
				{...messages.microsoftTeams}
				values={{
					enabled: disabled ? 'no' : 'yes',
				}}
			/>
		);
	} else if (name === BENEFIT_REALTIME_INDEX_NOW) {
		return (
			<FormattedMessage
				{...messages.realtimeIndexNow}
				values={{
					enabled: disabled ? 'no' : 'yes',
				}}
			/>
		);
	} else if (name === BENEFIT_RENDERING) {
		return (
			<FormattedMessage
				{...messages.rendering}
				values={{
					enabled: disabled ? 'no' : 'yes',
				}}
			/>
		);
	} else if (name === BENEFIT_REPORTING_API) {
		return (
			<FormattedMessage
				{...messages.reportingApi}
				values={{
					enabled: disabled ? 'no' : 'yes',
				}}
			/>
		);
	} else if (name === BENEFIT_UNLIMITED_USERS) {
		return (
			<FormattedMessage {...messages.unlimitedUsers} />
		);
	} else if (name === BENEFIT_UNLIMITED_WEBSITES) {
		return (
			<FormattedMessage {...messages.unlimitedWebsites} />
		);
	}

	return null;
};



export default BenefitLabel;
